var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.01 22.577V9.382c0-1.244 1.502-1.87 2.385-.994l6.627 6.568a1.4 1.4 0 01.005 1.984L14.4 23.567c-.882.882-2.39.257-2.39-.99z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMi4wMDk4IDIyLjU3NzFWOS4zODIxMUMxMi4wMDk4IDguMTM3ODYgMTMuNTExNSA3LjUxMTg3IDE0LjM5NTMgOC4zODc3NkwyMS4wMjIyIDE0Ljk1NThDMjEuNTczMSAxNS41MDE4IDIxLjU3NTEgMTYuMzkxNyAyMS4wMjY3IDE2Ljk0MDFMMTQuMzk5NyAyMy41NjcxQzEzLjUxNzggMjQuNDQ5IDEyLjAwOTggMjMuODI0NCAxMi4wMDk4IDIyLjU3NzFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { Svg32 as ReactComponent };